const PurgeReasons = {
  DMG: {
    id: 'DMG',
    humanReadableName: 'Damaged - Item Damaged / Cannot Ship'
  },
  CLEAN: {
    id: 'CLEAN',
    humanReadableName: 'Cleanup - Cleanup of Closed Items'
  },
  MISC: {
    id: 'MISC',
    humanReadableName: 'Miscellaneous'
  }
}

export default PurgeReasons
